module.exports = __webpack_public_path__ + "static/media/paintings.e4198cb4.jpg";